"use client"

import { createContext, useContext } from "react"

interface LocaleContextType {
  locale: string
}

const LocaleContext = createContext<LocaleContextType>({ locale: "en-US" })

export function LocaleProvider({
  locale,
  children,
}: {
  locale: string
  children: React.ReactNode
}) {
  return (
    <LocaleContext.Provider value={{ locale }}>
      {children}
    </LocaleContext.Provider>
  )
}

export function useLocale() {
  const context = useContext(LocaleContext)
  if (!context) {
    throw new Error("useLocale must be used within a LocaleProvider")
  }
  return context.locale
}
